import Swal from "sweetalert2";

export const baseAlert = (title: string | undefined, subTitle: string | undefined, type: any) => Swal.fire(title, subTitle, type);


export const AlertWithActionButtons = (title: string | undefined, subTitle: string | undefined,
     buttonOneTitle: string, buttonTwoTitle: string, icon) => {

        const newSwal = Swal.mixin({
            customClass: {
                confirmButton: "button button-create",
                denyButton: "button button-view"
            },
            buttonsStyling: false,
        })

        return newSwal.fire({
            title: title,
            text: subTitle,
            showDenyButton: true,
            confirmButtonText: buttonOneTitle,
            denyButtonText: buttonTwoTitle,
            reverseButtons: true,
            icon: icon
        })
     }